document.addEventListener("DOMContentLoaded", function () {
    const accordionButtons = document.querySelectorAll('.accordion-button');

    accordionButtons.forEach(button => {
        button.addEventListener('click', function () {
            const expanded = this.getAttribute('aria-expanded') === 'true';
            const content = this.nextElementSibling;
            console.log(content)

            // Toggle button aria-expanded state
            this.setAttribute('aria-expanded', !expanded);

            // Toggle content visibility
            if (expanded) {
                content.setAttribute('aria-expanded', 'false');
                content.style.maxHeight = '0';
            } else {
                content.setAttribute('aria-expanded', 'true');
                content.style.maxHeight = content.scrollHeight + 'px'; // Expand to the full content height
            }
        });
    });
});


jQuery(document).ready(function ($) {
    var nav = jQuery('#site-navigation'), button, menu;
    if (!nav)
        return;

    button = nav.find('.menu-toggle');
    if (!button)
        return;

    // Hide button if menu is missing or empty.
    menu = nav.find('.twentyfive-nav');
    if (!menu || !menu.children().length) {
        button.hide();
        return;
    }

    jQuery('.menu-toggle').on('click', function () {
        nav.toggleClass('toggled-on');
    });

    jQuery('.righticon').on('click', function () {
        if (jQuery(this).parent().siblings('.sub-menu, .children, .mega-sub-menu').hasClass('open')) {
            jQuery(this).parent().siblings('.sub-menu, .children, .mega-sub-menu').removeClass('open');
            jQuery(this).removeClass('angle-up').addClass('angle-down');
        } else {
            jQuery(this).parent().siblings('.sub-menu, .children, .mega-sub-menu').addClass('open');
            jQuery(this).removeClass('angle-down').addClass('angle-up');
        }
        return false;
    });
});